import React, { useState } from 'react';
import { Box } from '@mui/material';
import SalesActionTimeline from './SalesActionTimeline';
import SalesActionForm from './SalesActionForm';
import ActivityRegisterModal from './ActivityRegisterModal';
import CalendarGrid from './CalendarGrid'; 
import ActivityDailyModal from './ActivityDailyModal';

const ALLOWED_PATH = '/salesAction'; 


const SalesActionLog = ({ 
    events, 
    actionEvents,    
    onSaveAction, 
    onDeleteAction, 
    isCalFull,
    selectedDate,    
    onDateChange,
    shouldResetForm,
    setShouldResetForm     
}) => {
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const handleSelectSchedule = (scheduleData) => {
        setSelectedSchedule(scheduleData);
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', md: 'row' }, 
                width: '100%', 
                height: '100%',
                gap: 4,
                p: 2,
                backgroundColor: '#ffffff'
            }}
        >
            <Box 
                sx={{ 
                    flex: { xs: 'none', md: 2 }
                }}
            >
                <SalesActionTimeline 
                    event={events}
                    actionEvents={actionEvents} 
                    selectedDate={selectedDate} 
                    onDateChange={onDateChange}
                    onSelectSchedule={handleSelectSchedule}
                />
            </Box>

            <Box 
                sx={{ 
                    flex: { xs: 'none', md: 3 },
                    p: 0.5
                }}
            >
                <SalesActionForm 
                    selectedSchedule={selectedSchedule}
                    selectedDate={selectedDate}
                    onDateChange={onDateChange}
                    onSaveAction={onSaveAction}
                    onDeleteAction={onDeleteAction}
                    shouldResetForm={shouldResetForm}
                    setShouldResetForm={setShouldResetForm}
                />
            </Box>
        </Box>
    );
};

export default SalesActionLog;
